import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_LISTING_SHOULD_CHARGE_WITHDRAW_FEE,
} from 'api/actionTypes';

export default async function shouldChargeWithdrawFee({ state, apiClient }, { listingId, reload = false }) {
  typeCheck('listingId::PositiveNumber', listingId);
  const statePath = ['listings', 'shouldChargeWithdrawFee', listingId];
  if (state.exists(statePath) && !reload) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LISTING_SHOULD_CHARGE_WITHDRAW_FEE,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
    },
    onSuccess(should) {
      state.set(statePath, should);
    },
  });
}
